import React from 'react';
// icons
import { BiError } from 'react-icons/bi';

// components
import AampeIconBackground from '../../../../components/shared/AampeIconBackground/AampeIconBackground';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

const TestFormulaError: React.FC<
    React.PropsWithChildren<{ contactId: string }>
> = ({ contactId }) => {
    return (
        <>
            <AampeIconBackground
                primaryColor={aampeTheme.colors.error50}
                secondaryColor={aampeTheme.colors.error100}
            >
                <BiError color={aampeTheme.colors.error500} />
            </AampeIconBackground>

            <Heading>Something went wrong</Heading>
            <Paragraph>
                We are unable to send a message to{' '}
                <span style={{ fontWeight: 'bold' }}>{contactId}</span>
            </Paragraph>
            <FooterParagraph>
                Our technical team has been notified.
            </FooterParagraph>
        </>
    );
};

const Heading = styled.h1(() => ({
    fontSize: '20px',
    paddingTop: aampeTheme.spacing(1),
    color: aampeTheme.colors.error400,
}));

const Paragraph = styled.p(() => ({
    paddingTop: aampeTheme.spacing(1),
    fontSize: '14px',
    textAlign: 'center',
}));

const FooterParagraph = styled.p(() => ({
    fontSize: '14px',
    paddingTop: aampeTheme.spacing(3),
    color: aampeTheme.colors.solidA01,
}));

export default TestFormulaError;
